<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="table-responsive">
    <b-table
      striped
      hover
      fixed
      show-empty
      responsive
      stacked="md"
      :busy="loading"
      :fields="fields"
      :items="canRead(access) ? data : []"
      style="border-radius: 10px; overflow: scroll; max-height: 500px;"
    >
      <template v-slot:table-busy="">
        <div class="text-center text-danger my-2">
          <wave-loader />
        </div>
      </template>
      <template v-slot:cell(action)="data">
        <div class="text-center">
          <master-config-ae-edit
            :access="'master_config_ae'"
            :formData="data.item"
            @onDeleteClicked="onActionDelete"
            @onViewClicked="onActionView"
            @onEditClicked="onActionEdit"/>
        </div>
      </template>
    </b-table>
    <b-pagination
      v-model="pagination.current"
      :per-page="pagination.pageSize"
      :total-rows="pagination.totalSize"
      @change="onPaginationChanged"
    ></b-pagination>
  </div>
</template>

<script>
import { formatDateTime } from '@/util/date';
import { DISPLAY_DATE } from '@/util/apiDatetime';
import MasterConfigAeEdit from './Edit';

export default {
  name: 'MasterConfigAeList',
  components: { MasterConfigAeEdit },
  props: ['access', 'data', 'group', 'loading', 'pagination'],
  data() {
    return {
      fields: [
        {
          key: 'mcaeDevcId',
          label: 'Devc Id',
          class: 'text-center',
          thStyle: { minWidth: '100px' },
        },
        {
          key: 'mrtaDevc.devcUniqueId',
          label: 'Unique Id',
          class: 'text-center',
          thStyle: { minWidth: '100px' },
        },
        {
          key: 'mcaeNo',
          label: 'No',
          class: 'text-center',
          thStyle: { minWidth: '50px' },
        },
        {
          key: 'mcaeConsumptRateByTime',
          label: 'Rate By Time',
          class: 'text-center',
          thStyle: { minWidth: '150px' },
        },
        {
          key: 'mcaeConsumptRateByPower',
          label: 'Rate By Power',
          class: 'text-center',
          thStyle: { minWidth: '150px' },
        },
        {
          key: 'mcaeConsumptRateByRpm',
          label: 'Rate By Rpm',
          class: 'text-center',
          thStyle: { minWidth: '150px' },
        },
        {
          key: 'action',
          label: '',
          class: 'text-center',
          thStyle: { minWidth: '100px' },
        },
      ],
    };
  },
  methods: {
    dateWithDDMMYYYYFormat(v) {
      return formatDateTime(v, DISPLAY_DATE);
    },
    onPaginationChanged(page) {
      this.$emit('onPageChanged', page);
    },
    onActionDelete(data) {
      this.$emit('onActionDelete', data);
    },
    onActionEdit(data) {
      this.$emit('onActionEdit', data);
    },
    onActionView(data) {
      this.$emit('onActionView', data);
    },
  },
};
</script>

<style scoped>

</style>
